
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1fcus_1jkw2_145",
  "clickable": "awsui_clickable_1fcus_1jkw2_154",
  "precise": "awsui_precise_1fcus_1jkw2_158",
  "focus-outline": "awsui_focus-outline_1fcus_1jkw2_162",
  "application": "awsui_application_1fcus_1jkw2_171"
};
  